'use strict';

var React = require('react');
require('../../../theme/breakpoints.js');
var useIMask = require('../../../hooks/useIMask.js');
require('resize-observer-polyfill');

const usePatternMask = ({ inputRef: getInput, pattern, value, onChange, definitions }) => {
    const maskRef = useIMask.useIMaskInstance({
        inputRef: getInput,
        options: React.useMemo(() => ({ mask: pattern, definitions }), [definitions, pattern]),
    });
    useIMask.useIMaskAcceptListener(maskRef, React.useCallback(event => onChange(maskRef.current?.unmaskedValue ?? '', event), [onChange]));
    React.useEffect(() => {
        const mask = maskRef.current;
        if (mask && value !== mask.unmaskedValue) {
            mask.unmaskedValue = value;
        }
    }, [value, maskRef]);
};

exports.usePatternMask = usePatternMask;
//# sourceMappingURL=usePatternMask.js.map
